import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//
import { doAccessAction } from 'store/actions/role-list.actions';
import {
  changeDataProcessingState,
  getActivityNew,
} from 'store/actions/activity.actions';
import { API_METHODS } from 'config/constants';
import { getUserRoleLabel } from 'utils/business-logic/getUserRoleFromGroupsList';
import { Loader } from 'components';
import ComplexSuccessIcon from 'components/SvgIcons/ComplexIcons/success.svg';
import ComplexCrossIcon from 'components/SvgIcons/ComplexIcons/cross.svg';
import { MODAL_TYPES } from '../constants';
import { ROLES } from '../../../config/constants';
import { NotesForm } from './NotesForm';
import { getDeclineDescription } from './messages';

@connect(
  ({ roleList: { processing = {}, sponsorProfileRequests = {} } }, props) => ({
    processing: processing[`disconnect-${props.options.userId}`],
    sponsorProfileRequests,
  }),
  (dispatch) => ({
    doAccessAction: bindActionCreators(doAccessAction, dispatch),
    changeDataProcessingState: bindActionCreators(
      changeDataProcessingState,
      dispatch,
    ),
    getActivityNew: bindActionCreators(getActivityNew, dispatch),
  }),
)
export class DeclineModal extends React.PureComponent {
  static propTypes = {
    doAccessAction: PropTypes.func,
    changeDataProcessingState: PropTypes.func,
    getActivityNew: PropTypes.func,
    options: PropTypes.shape({
      userRole: PropTypes.string,
      userId: PropTypes.string,
      listDataKey: PropTypes.string,
      actionCb: PropTypes.func,
    }),
  };

  static defaultProps = {
    options: {},
  };

  handleSubmit = async (values) => {
    const {
      doAccessAction,
      changeDataProcessingState,
      options: {
        profileSource,
        requestId,
        userId,
        listDataKey,
        actionCb,
        userRole,
        url,
        method = 'put',
        handleReloadPage,
      } = {},
    } = this.props;
    const urlLocal = profileSource
      ? userRole === ROLES.PERSONNEL
        ? API_METHODS.LINKING_REQUEST_DECLINE(requestId)
        : API_METHODS.ACCESS_INVITE_DENY_PROFILE(userId)
      : API_METHODS.ACCESS_INVITE_DENY(requestId);

    changeDataProcessingState(true, 'processingActivityNew');

    const response = await doAccessAction({
      url: url || urlLocal,
      requestMethod: method,
      body: { ...values },
      requestId: requestId && requestId,
      processingKey: `disconnect-${userId}`,
      stateKeyForDataSaving: listDataKey,
      rewriteAccessRequestKey: requestId && 'requestId',
    });

    const { showModal } = this.props;

    if (!response || response.code !== 'success') {
      changeDataProcessingState(false, 'processingActivityNew');
      return showModal(MODAL_TYPES.INFO, {
        withCross: false,
        icon: <ComplexCrossIcon />,
        text: 'Ooops….something went wrong.',
        body: 'Your request is not sent. Please try again later.',
        additionalClassName: 'p-15',
      });
    }

    showModal(MODAL_TYPES.INFO, {
      withCross: false,
      icon: <ComplexSuccessIcon />,
      text: `${userRole.replace(/([A-Z])/g, ' $1')} is not linked.`,
      additionalClassName: 'p-15',
      handleReloadPage: handleReloadPage,
    });
    actionCb && actionCb();
  };

  render() {
    const { options: { userRole, title = 'Decline connection' } = {} } =
      this.props;
    const roleLabel = getUserRoleLabel(userRole);

    return (
      <Loader isShow={this.props.processing}>
        <div className="white-box p-15 text-left" style={{ maxWidth: '550px' }}>
          <div className="montserrat bold fs-16">{title}</div>
          <div className="fs-12 mt-2">{getDeclineDescription(userRole)}</div>
          <NotesForm
            notesPlaceholder={`Add notes for ${roleLabel}`}
            onSubmit={this.handleSubmit}
          />
        </div>
      </Loader>
    );
  }
}
